import { render } from "./FichasView.vue?vue&type=template&id=554a0995"
import script from "./FichasView.vue?vue&type=script&lang=js"
export * from "./FichasView.vue?vue&type=script&lang=js"

import "./FichasView.vue?vue&type=style&index=0&id=554a0995&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__